@for (diffField of diffFields; track $index) {
  <dl>
    <dt class="mb-2 font-semibold leading-none text-gray-700 flex items-center">{{ diffField.label }}</dt>
    <dd class="mb-4 font-light text-gray-500 sm:mb-5">
      <app-diff-field-viewer [diffField]="diffField"></app-diff-field-viewer>
    </dd>
  </dl>
}
